import { INlpRequest, INlpResponse } from '@common/types';
import { PYTHON_BACKEND } from '@constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod, HttpStatus } from '@constants/http';
import { TFunction } from 'i18next';

export async function fetchQuery(query: INlpRequest, t: TFunction): Promise<INlpResponse | void> {
  const baseUrl = PYTHON_BACKEND;
  const endpoint = ApiEndpoint.CuratedQuery;
  const url = `${baseUrl}/${endpoint}/`;
  const requestOptions = {
    method: HttpMethod.POST,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
    body: JSON.stringify({ ...query }),
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (!response.ok) {
      if (response.status === HttpStatus.BadRequest) {
        const error: string = data.error;
        if (error.includes('not a valid value for User query')) {
          return {
            status: HttpStatus.BadRequest,
            error,
          };
        }
      }
      if (response.status === HttpStatus.NotFound) {
        const error: string = data.error;
        if (error.includes('Curated Query with query')) {
          return {
            status: HttpStatus.NotFound,
            error,
          };
        }
      }
      if (
        [
          HttpStatus.UnprocessableContent,
          HttpStatus.InternalServerError,
          HttpStatus.BadGateway,
          HttpStatus.ServiceUnavailable,
        ].includes(response.status)
      ) {
        return {
          status: HttpStatus.InternalServerError,
          error: t('common.general_error'),
        };
      }
      if (data && data.message) {
        throw new Error(data.message);
      }
      throw new Error('[api.fetch-query]: Something went wrong!');
    }
    return data;
  } catch (error: unknown) {
    console.error(error);
    return {
      status: HttpStatus.InternalServerError,
      error: t('common.general_error'),
    };
  }
}
